<template>
  <div>
    <nav class="mobile-bottom-nav">
      <div class="mobile-bottom-nav__item mobile-bottom-nav__item--active">
        <div class="mobile-bottom-nav__item-content" @click="homePage">
          <i class="fa-solid fa-house-chimney"></i>
          <span>{{$t('menu.home') }}</span>

        </div>
      </div>
      <!-- <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="homeWheel">
          <i class="fa-solid fa-dharmachakra"></i>
          <span>Quay thưởng</span>
        </div>
      </div> -->
      <!-- <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="homeGift">
          <i class="fa-solid fa-gift"></i>
          <span>Đổi thưởng </span>
        </div>
      </div> -->
            <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="homeProduct">
          <i class="fa-brands fa-product-hunt"></i>
          <span>{{$t('menu.products') }}</span>
        </div>
      </div>
      <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="cart">
          <i class="fas fa-cart-plus"></i>
          <span>{{$t('menu.cart') }}</span>
        </div>
      </div>


      <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="favourite">
          <i class="far fa-heart"></i>
          <span>{{$t('text.favourite') }}</span>
        </div>
      </div>
      <div class="mobile-bottom-nav__item">
        <div class="mobile-bottom-nav__item-content"  @click="homeUser">
          <i class="fa-solid fa-user"></i>
          <span>{{$t('menu.user') }}</span>
        </div>
      </div>
    </nav>
  </div>
</template>
<script lang="ts" setup>
import commons from "@/utils/Common";
import { watch, reactive, ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const homePage = () => {
  router.push({ path: "./" })
}

const homeWheel = () => {
  router.push({ path: "/roulette" })
}

const homeGift = () => {
  router.push({ path: "/gift" })
}

const cart = () => {
  router.push({ path: "/cart" })
}

const homeProduct = () => {
  router.push({ path: "/products" })
}

const homeUser = () => {
  router.push({ path: "/inform" })
}

const favourite = () => {
  router.push({ path: "/favourite" })
}
</script>
<style>
@media (min-width: 676px) {
	.mobile-bottom-nav {
		display: block !important;
	}
}

@media (min-width: 677px) {
	.mobile-bottom-nav {
		display: none !important;
	}
}
.mobile-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  will-change: transform;
  transform: translateZ(0);
  display: flex;
  height: 50px;
  box-shadow: 0 -2px 5px -2px #333;
  /* background-color: #fff; */
  background: linear-gradient(270deg, #102542, #102542 81.56%, #102542);
  
   /* background:linear-gradient(0deg, rgba(64, 83, 94, 1) 0%, rgba(8, 24, 52, 0) 100%); */
}

.mobile-bottom-nav__item {
  flex-grow: 1;
  text-align: center;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* .mobile-bottom-nav__item--active {
  color: #333333 !important;
} */
.mobile-bottom-nav__item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #d4af37;
}

.mobile-bottom-nav__item-content i {
  font-size: x-large;
}

.mobile-bottom-nav__item-content:hover {
  cursor: pointer;
}

.mobile-bottom-nav__item--active .mobile-bottom-nav__item-content {
  color: #fff;
  font-weight: 700;
}</style>